import React, { useEffect, useRef } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import classNames from 'classnames';
import { editStatus } from '../redux/state/status';

interface Props {
    height: number;
}

const ImageModal = (props:Props) => {
    // console.log("IMAGE MODAL HERE")

    const isImageModal = useSelector(
        (state: { status: { isImageModal: boolean } }) =>
            state.status.isImageModal
    );

    const imageUrl = useSelector(
        (state: { status: { imageUrl: string } }) => state.status.imageUrl
    );

    // console.log("VALUES SENT", isImageModal, imageUrl);

    const dispatch = useDispatch();
    const handleClick = () => {
        dispatch(editStatus({ name: 'isImageModal', value: false }));
    };

    // The overlay stays mounted, so a tall image would otherwise open at the
    // scroll offset left by the previously viewed image.
    const scrollRef = useRef<HTMLDivElement>(null);
    useEffect(() => {
        if (isImageModal && scrollRef.current) {
            scrollRef.current.scrollTop = 0;
        }
    }, [isImageModal, imageUrl]);

    return (
        <div
            ref={scrollRef}
            style={{ height: props.height }}
            className={classNames(
                'absolute inset-x-0 top-0 w-screen bg-zinc-800 z-20 overflow-y-auto overflow-x-hidden',
                { hidden: !isImageModal }
            )}
        >
            <div className="sticky top-0 z-30 h-0">
                <img
                    onClick={handleClick}
                    alt="icon"
                    src="https://cdn-icons-png.flaticon.com/512/458/458594.png"
                    className="absolute right-6 top-4 h-10 cursor-pointer"
                />
            </div>

            <div className="flex min-h-full items-center justify-center px-4 py-14">
                <img
                    src={imageUrl}
                    alt="preview"
                    draggable={false}
                    className="block max-w-full h-auto object-contain touch-pan-y touch-pinch-zoom chat--disapear active"
                />
            </div>
        </div>
    );
};

export default ImageModal;
